import { Component, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ProductCategory } from 'app/entities';
import { Subject } from 'rxjs';
import { openCatalogFormDialog } from '../catalog-form-dialog/catalog-form-dialog.component';

// Botão de cadastro/edição: abre o formulário em diálogo (antes era um mat-menu).
@Component({
  selector: 'app-card-drop-down-product-category-create',
  templateUrl: './card-drop-down-product-category-create.component.html',
})
export class CardDropDownProductCategoryCreateComponent {

  @Input() appearance: string = 'standard';
  @Input() productCategory: ProductCategory | null = null;
  @Output() onCreated = new Subject<ProductCategory>();
  @Output() onUpdated = new Subject<ProductCategory>();
  @Input() responsiveBtn = false;
  // Só ícone (ex.: criar dentro de um select): recebe aria-label e tooltip
  @Input() iconOnly = false;
  readonly label = 'Nova categoria';

  constructor(private _dialog: MatDialog) { }

  onClick(event: Event) {
    // Item de menu (Editar): deixa o menu da linha fechar. Nos demais casos (ex.: dentro
    // da busca de um select) o clique não pode chegar à opção do select.
    if (this.appearance !== 'mat-menu-item') {
      event.stopPropagation();
    }
    this.open();
  }

  open() {
    openCatalogFormDialog<ProductCategory>(this._dialog, { kind: 'category', entity: this.productCategory })
      .subscribe((result) => {
        if (result?.action === 'created') {
          this.onCreated.next(result.value);
        } else if (result?.action === 'updated') {
          this.onUpdated.next(result.value);
        }
      });
  }

}
